import { Divider, Grid } from '@mui/material';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { DatePicker } from '@mui/lab';
import { AccordionResidenceVM } from 'cohabitation/view-models/detail-cohabitation';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
// import ToponymName from './toponym-name';
import { FormikErrors, FormikTouched } from 'formik';
import MunicipalityList from 'shell/components/shared/municipality-list';

interface FormResidenceProps {
  disabled?: boolean;
  values?: AccordionResidenceVM;
  isEditMode?: boolean;
  onChange: (
    key: keyof AccordionResidenceVM,
    value: AccordionResidenceVM[keyof AccordionResidenceVM]
  ) => void;
  errors?: FormikErrors<AccordionResidenceVM>;
  touched?: FormikTouched<AccordionResidenceVM>;
}

const FormResidenceComponent = ({
  disabled,
  values,
  onChange,
  isEditMode,
  errors,
  touched,
}: FormResidenceProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item container spacing={2} xs={12}>
        <Grid item xs={12} md={3}>
          <PmiTextField
            aria-label="Tipo Residenza"
            label="Tipo Residenza"
            id="type"
            name="type"
            fullWidth
            disabled={isEditMode ? false : disabled}
            type="text"
            onChange={(event) => {
              onChange('type', event.target.value);
            }}
            variant="outlined"
            value={values?.type || ''}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <DatePicker
            label="Data decorrenza"
            value={values?.effectiveDate || null}
            disabled={isEditMode ? false : disabled}
            onChange={(dataValue) => {
              onChange('effectiveDate', dataValue || null);
            }}
            renderInput={(params) => (
              <PmiTextField
                {...params}
                id="effectiveDate"
                fullWidth
                error={touched?.effectiveDate && Boolean(errors?.effectiveDate)}
                helperText={errors?.effectiveDate}
              />
            )}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} md={8}>
        <MunicipalityList
          label="Comune"
          aria-label="Comune"
          value={values?.municipality || null}
          disabled
          onChange={(element) => {
            onChange('municipality', element);
          }}
          error={touched?.municipality && Boolean(errors?.municipality)}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Provincia"
          id="province"
          inputProps={{
            maxLength: '2',
          }}
          aria-label="Provincia"
          fullWidth
          value={values?.municipality?.province || ''}
          disabled
        />
      </Grid>
      <Grid item container spacing={2} xs={12}>
        <Grid item xs={12} md={9}>
          <PmiTextField
            aria-label="Località"
            label="Località"
            id="locality"
            name="locality"
            fullWidth
            disabled={isEditMode ? false : disabled}
            type="text"
            onChange={(event) => {
              onChange('locality', event.target.value);
            }}
            variant="outlined"
            value={values?.locality || ''}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <PmiTextField
            aria-label="CAP"
            label="CAP"
            id="cap"
            name="cap"
            disabled={isEditMode ? false : disabled}
            fullWidth
            type="text"
            onChange={(event) => {
              onChange('cap', event.target.value);
            }}
            variant="outlined"
            value={values?.cap || ''}
            error={touched?.cap && Boolean(errors?.cap)}
            helperText={errors?.cap}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} md={9}>
        <PmiTextField
          aria-label="Presso"
          label="Presso"
          id="at"
          name="at"
          fullWidth
          disabled={isEditMode ? false : disabled}
          type="text"
          onChange={(event) => {
            onChange('at', event.target.value);
          }}
          variant="outlined"
          value={values?.at || ''}
        />
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <PmiTitleDivider>Toponimo</PmiTitleDivider>
      </Grid>
      <Grid item container spacing={2} xs={12}>
        <Grid item xs={12} md={4}>
          <PmiTextField
            aria-label="Codice"
            label="Codice"
            id="code"
            fullWidth
            disabled={disabled}
            type="text"
            variant="outlined"
            value={values?.code || ''}
            onChange={(event) => {
              onChange('code', event.target.value);
            }}
            // error={
            //   filterPersonForm.touched.municipalityId &&
            //   Boolean(filterPersonForm.errors.municipalityId)
            // }
            // helperText={filterPersonForm.errors.municipalityId}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <PmiTextField
            aria-label="Specie"
            label="Specie"
            id="kind"
            name="kind"
            fullWidth
            disabled={disabled}
            type="text"
            variant="outlined"
            value={values?.kind || ''}
            onChange={(event) => {
              onChange('kind', event.target.value);
            }}
            // error={
            //   filterPersonForm.touched.istatCode && Boolean(filterPersonForm.errors.istatCode)
            // }
            // helperText={filterPersonForm.errors.istatCode}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <PmiTextField
            aria-label="Denominazione"
            label="Denominazione"
            id="name"
            name="name"
            fullWidth
            disabled={disabled}
            type="text"
            variant="outlined"
            value={values?.name || ''}
            onChange={(event) => {
              onChange('name', event.target.value);
            }}
            // error={filterPersonForm.touched.anprId && Boolean(filterPersonForm.errors.anprId)}
            // helperText={filterPersonForm.errors.anprId}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <PmiTextField
            aria-label="Fonte toponimo"
            label="Fonte toponimo"
            id="source"
            name="source"
            fullWidth
            disabled={disabled}
            type="text"
            variant="outlined"
            value={values?.source || ''}
            onChange={(event) => {
              onChange('source', event.target.value);
            }}
            // error={
            //   filterPersonForm.touched.municipalityId &&
            //   Boolean(filterPersonForm.errors.municipalityId)
            // }
            // helperText={filterPersonForm.errors.municipalityId}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <PmiTextField
            aria-label="Codice Specie"
            label="Codice Specie"
            id="kindCode"
            name="kindCode"
            fullWidth
            disabled={disabled}
            type="text"
            variant="outlined"
            value={values?.kindCode || ''}
            onChange={(event) => {
              onChange('kindCode', event.target.value);
            }}
            // error={
            //   filterPersonForm.touched.istatCode && Boolean(filterPersonForm.errors.istatCode)
            // }
            // helperText={filterPersonForm.errors.istatCode}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <PmiTextField
            aria-label="Fonte specie"
            label="Fonte specie"
            id="kindSource"
            name="kindSource"
            fullWidth
            disabled={disabled}
            type="text"
            variant="outlined"
            value={values?.kindSource || ''}
            onChange={(event) => {
              onChange('kindSource', event.target.value);
            }}
            // error={filterPersonForm.touched.anprId && Boolean(filterPersonForm.errors.anprId)}
            // helperText={filterPersonForm.errors.anprId}
          />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item container spacing={2} xs={12}>
        <Grid item xs={12} md={3}>
          <PmiTextField
            aria-label="Numero"
            label="Numero"
            id="civic-number"
            name="civic-number"
            fullWidth
            disabled={disabled}
            type="text"
            variant="outlined"
            value={values?.number || ''}
            onChange={(event) => {
              onChange('number', event.target.value);
            }}
            // error={
            //   filterPersonForm.touched.municipalityId &&
            //   Boolean(filterPersonForm.errors.municipalityId)
            // }
            // helperText={filterPersonForm.errors.municipalityId}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <PmiTextField
            aria-label="Lettera"
            label="Lettera"
            id="letter"
            name="letter"
            fullWidth
            disabled={disabled}
            type="text"
            variant="outlined"
            inputProps={{
              maxLength: '1',
            }}
            value={values?.letter || ''}
            onChange={(event) => {
              onChange('letter', event.target.value);
            }}
            // error={
            //   filterPersonForm.touched.letter && Boolean(filterPersonForm.errors.letter)
            // }
            // helperText={filterPersonForm.errors.letter}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <PmiTextField
            aria-label="Esponente"
            label="Esponente"
            id="exponent"
            name="exponent"
            fullWidth
            disabled={disabled}
            type="text"
            variant="outlined"
            value={values?.exponent || ''}
            onChange={(event) => {
              onChange('exponent', event.target.value);
            }}
            // error={filterPersonForm.touched.anprId && Boolean(filterPersonForm.errors.anprId)}
            // helperText={filterPersonForm.errors.anprId}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <PmiTextField
            aria-label="Colore"
            label="Colore"
            id="color"
            name="color"
            fullWidth
            disabled={disabled}
            type="text"
            variant="outlined"
            value={values?.color || ''}
            onChange={(event) => {
              onChange('color', event.target.value);
            }}
            // error={filterPersonForm.touched.anprId && Boolean(filterPersonForm.errors.anprId)}
            // helperText={filterPersonForm.errors.anprId}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <PmiTextField
            aria-label="Codice civico"
            label="Codice civico"
            id="civicCode"
            name="civicCode"
            fullWidth
            disabled={disabled}
            type="text"
            variant="outlined"
            value={values?.civicCode || ''}
            onChange={(event) => {
              onChange('civicCode', event.target.value);
            }}
            // error={
            //   filterPersonForm.touched.municipalityId &&
            //   Boolean(filterPersonForm.errors.municipalityId)
            // }
            // helperText={filterPersonForm.errors.municipalityId}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <PmiTextField
            aria-label="Civico fonte"
            label="Civico fonte"
            id="sourceCivic"
            name="sourceCivic"
            fullWidth
            disabled={disabled}
            type="text"
            variant="outlined"
            value={values?.sourceCivic || ''}
            onChange={(event) => {
              onChange('sourceCivic', event.target.value);
            }}
            // error={
            //   filterPersonForm.touched.istatCode && Boolean(filterPersonForm.errors.istatCode)
            // }
            // helperText={filterPersonForm.errors.istatCode}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <PmiTextField
            aria-label="Metrica"
            label="Metrica"
            id="metric"
            name="metric"
            fullWidth
            disabled={disabled}
            type="text"
            variant="outlined"
            value={values?.metric || ''}
            onChange={(event) => {
              onChange('metric', event.target.value);
            }}
            // error={filterPersonForm.touched.anprId && Boolean(filterPersonForm.errors.anprId)}
            // helperText={filterPersonForm.errors.anprId}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <PmiTextField
            aria-label="Prog.SNC"
            label="Prog.SNC"
            id="prog"
            name="prog"
            fullWidth
            disabled={disabled}
            type="text"
            variant="outlined"
            value={values?.prog || ''}
            onChange={(event) => {
              onChange('prog', event.target.value);
            }}
            // error={filterPersonForm.touched.anprId && Boolean(filterPersonForm.errors.anprId)}
            // helperText={filterPersonForm.errors.anprId}
          />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Corte"
          label="Corte"
          id="court"
          name="court"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.court || ''}
          onChange={(event) => {
            onChange('court', event.target.value);
          }}
          // error={
          //   filterPersonForm.touched.municipalityId &&
          //   Boolean(filterPersonForm.errors.municipalityId)
          // }
          // helperText={filterPersonForm.errors.municipalityId}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Scala"
          label="Scala"
          id="scale"
          name="scale"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.scale || ''}
          onChange={(event) => {
            onChange('scale', event.target.value);
          }}
          // error={
          //   filterPersonForm.touched.istatCode && Boolean(filterPersonForm.errors.istatCode)
          // }
          // helperText={filterPersonForm.errors.istatCode}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Interno1"
          label="Interno1"
          id="firstIntern"
          name="firstIntern"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.firstIntern || ''}
          onChange={(event) => {
            onChange('firstIntern', event.target.value);
          }}
          // error={filterPersonForm.touched.anprId && Boolean(filterPersonForm.errors.anprId)}
          // helperText={filterPersonForm.errors.anprId}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Esponente interno1"
          label="Esponente interno1"
          id="exponentFirstIntern"
          name="exponentFirstIntern"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.exponentFirstIntern || ''}
          onChange={(event) => {
            onChange('exponentFirstIntern', event.target.value);
          }}
          // error={filterPersonForm.touched.anprId && Boolean(filterPersonForm.errors.anprId)}
          // helperText={filterPersonForm.errors.anprId}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Scala esterna"
          label="Scala esterna"
          id="externalScale"
          name="externalScale"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.externalScale || ''}
          onChange={(event) => {
            onChange('externalScale', event.target.value);
          }}
          // error={
          //   filterPersonForm.touched.municipalityId &&
          //   Boolean(filterPersonForm.errors.municipalityId)
          // }
          // helperText={filterPersonForm.errors.municipalityId}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Secondario"
          label="Secondario"
          id="secondary"
          name="secondary"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.secondary || ''}
          onChange={(event) => {
            onChange('secondary', event.target.value);
          }}
          // error={
          //   filterPersonForm.touched.istatCode && Boolean(filterPersonForm.errors.istatCode)
          // }
          // helperText={filterPersonForm.errors.istatCode}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Interno2"
          label="Interno2"
          id="secondaryIntern"
          name="secondaryIntern"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.secondaryIntern || ''}
          onChange={(event) => {
            onChange('secondaryIntern', event.target.value);
          }}
          // error={filterPersonForm.touched.anprId && Boolean(filterPersonForm.errors.anprId)}
          // helperText={filterPersonForm.errors.anprId}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Esponente interno2"
          label="Esponente interno2"
          id="exponentSecondaryIntern"
          name="exponentSecondaryIntern"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.exponentSecondaryIntern || ''}
          onChange={(event) => {
            onChange('exponentSecondaryIntern', event.target.value);
          }}
          // error={filterPersonForm.touched.anprId && Boolean(filterPersonForm.errors.anprId)}
          // helperText={filterPersonForm.errors.anprId}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Piano"
          label="Piano"
          id="floor"
          name="floor"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.floor || ''}
          onChange={(event) => {
            onChange('floor', event.target.value);
          }}
          // error={
          //   filterPersonForm.touched.istatCode && Boolean(filterPersonForm.errors.istatCode)
          // }
          // helperText={filterPersonForm.errors.istatCode}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Nui"
          label="Nui"
          id="nui"
          name="nui"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.nui || ''}
          onChange={(event) => {
            onChange('nui', event.target.value);
          }}
          // error={filterPersonForm.touched.anprId && Boolean(filterPersonForm.errors.anprId)}
          // helperText={filterPersonForm.errors.anprId}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Isolato"
          label="Isolato"
          id="isolated"
          name="isolated"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.isolated || ''}
          onChange={(event) => {
            onChange('isolated', event.target.value);
          }}
          // error={filterPersonForm.touched.anprId && Boolean(filterPersonForm.errors.anprId)}
          // helperText={filterPersonForm.errors.anprId}
        />
      </Grid>
    </Grid>
  );
};

FormResidenceComponent.displayName = 'Form Residence component';

const FormResidence = memo(FormResidenceComponent);

export default FormResidence;
